import { resetZoom, zoomBy, zoomToFit } from '../canvas/cameraActions.ts'
import { showGrid, toggleGrid } from '../editor.ts'
import { scene } from '../scene/store.ts'
import { StylePanel } from './StylePanel.tsx'

export function StatusBar() {
  const zoomPct = () => Math.round(scene.camera.z * 100)

  return (
    <div class="statusbar">
      <StylePanel />

      <div class="zoom">
        <button
          type="button"
          classList={{ active: showGrid() }}
          title="Toggle grid (Ctrl ')"
          onClick={toggleGrid}
        >
          Grid
        </button>
        <button type="button" title="Zoom out (Ctrl -)" onClick={() => zoomBy(1 / 1.2)}>
          &minus;
        </button>
        <button type="button" title="Reset to 100% (Ctrl 0)" onClick={resetZoom}>
          {zoomPct()}%
        </button>
        <button type="button" title="Zoom in (Ctrl +)" onClick={() => zoomBy(1.2)}>
          +
        </button>
        <button type="button" title="Fit to content (Ctrl 1)" onClick={zoomToFit}>
          Fit
        </button>
      </div>
    </div>
  )
}
